import React, { useEffect, useRef } from 'react';
import styles from './HeaderSubMenu.module.scss';
import { PureHeaderSectionLink } from '../types';
import CtaLink, { LinkContext } from 'components/helpers/Atoms/Cta/CtaLink';
import { SvgIcon } from 'components/helpers/SvgIcon';
import useDictionary from 'lib/hooks/useDictionary';
interface HeaderSubMenuProps {
  sectionLink: PureHeaderSectionLink;
  onBack: () => void;
  firstInteractiveElementRef?: React.RefObject<HTMLButtonElement | null>;
  submenuId?: string;
  linkContext: LinkContext;
}

export const HeaderSubMenu = (props: HeaderSubMenuProps) => {
  const { sectionLink, onBack, firstInteractiveElementRef, submenuId, linkContext } = props;
  const { getDictionaryValue } = useDictionary();
  const backButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const elementToFocus = firstInteractiveElementRef?.current || backButtonRef.current;
    if (elementToFocus) {
      elementToFocus.focus();
    }
  }, [firstInteractiveElementRef]);

  return (
    <div id={submenuId} className={styles.subMenuWrapper}>
      <button
        ref={firstInteractiveElementRef || backButtonRef}
        className={styles.backButton}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onBack();
        }}
        aria-label={getDictionaryValue('Navigation.Header.BackToMainMenu') || 'Back to main menu'}
      >
        <SvgIcon icon="arrow-left" size="xxs" className={styles.backIcon} />
        <span className={styles.backText}>
          {getDictionaryValue('Navigation.Header.Back') || 'Back'}
        </span>
      </button>

      {sectionLink.sectionLinkList && sectionLink.sectionLinkList.length > 0 && (
        <div className={styles.subMenuItemsWrapper}>
          {sectionLink.sectionLinkLabel && sectionLink.sectionLinkUrl ? (
            <CtaLink
              text={sectionLink.sectionLinkLabel}
              url={sectionLink.sectionLinkUrl}
              ctaStyle="none"
              className={styles.subMenuTitle}
              ctaIconAfter="arrow-dash-right"
              ctaIconSize="sm"
              target={sectionLink.sectionLinkTarget}
              linkContext={linkContext}
            />
          ) : (
            <span className={styles.subMenuTitle}>{sectionLink.sectionLinkLabel}</span>
          )}
          <ul className={styles.subMenuList}>
            {sectionLink.sectionLinkList.map((link, index) => (
              <li key={index} className={styles.subMenuItem}>
                <CtaLink
                  text={link.sectionLinkLabel}
                  url={link.sectionLinkUrl}
                  ctaStyle="none"
                  className={styles.subMenuLink}
                  target={link.sectionLinkTarget}
                  linkContext={linkContext}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
